/* eslint-disable */

<template>
  <div>
    <div class="vx-row">

      <div class="vx-col lg:w-4/12 md:w-5/12 sm:w-5/5 mb-4">
        <div class="flex gap-2 mb-2">
          <vs-button :color="sel==='sw1'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw1'">SW1</vs-button>
          <vs-button :color="sel==='sw2'?'primary':'grey'" type="filled" class="flex-1" @click="sel='sw2'">SW2</vs-button>
        </div>

        <vx-card style="height: 42rem; overflow-y: auto">

          <!-- Tasks 1-3 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task123Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task123Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task123Done?'#28C76F':'#4a5568'}">1-3</span>
              <span class="font-semibold text-sm flex-1">LACP &amp; Port-Channel Configuration</span>
              <span class="text-xs font-medium" :class="task123Done?'text-success':'text-grey'">{{ task123Progress }}/12</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swKey in ['sw1','sw2']" :key="'t123-'+swKey" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ swKey.toUpperCase() }}</span>
                <div class="space-y-1 ml-1">
                  <div v-for="item in task123Items" :key="swKey+'-'+item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:getCompletion(swKey)[item.key]?'#28C76F':'transparent',border:'2px solid '+(getCompletion(swKey)[item.key]?'#28C76F':'#6b7280')}"></div>
                    <code class="text-base" :class="getCompletion(swKey)[item.key]?'text-success':''">{{ item.cmd }}</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Task 4 -->
          <div class="rounded-lg mb-3 overflow-hidden" :style="{border:'1px solid '+(task4Done?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:task4Done?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <span class="flex-shrink-0 rounded-full flex items-center justify-center font-bold text-white" :style="{width:'20px',height:'20px',fontSize:'10px',background:task4Done?'#28C76F':'#4a5568'}">4</span>
              <span class="font-semibold text-sm flex-1">Native VLAN 746 (MONITORING)</span>
              <span class="text-xs font-medium" :class="task4Done?'text-success':'text-grey'">{{ task4Progress }}/10</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swKey in ['sw1','sw2']" :key="'t4-'+swKey" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ swKey.toUpperCase() }}</span>
                <div class="space-y-1 ml-1">
                  <div v-for="item in task4Items" :key="swKey+'-'+item.key" class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:getCompletion(swKey)[item.key]?'#28C76F':'transparent',border:'2px solid '+(getCompletion(swKey)[item.key]?'#28C76F':'#6b7280')}"></div>
                    <code class="text-base" :class="getCompletion(swKey)[item.key]?'text-success':''">{{ item.cmd }}</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Save -->
          <div class="rounded-lg mb-2 overflow-hidden" :style="{border:'1px solid '+(saveDone?'#28C76F':'#3a3f51')}">
            <div class="flex items-center gap-2 px-3 py-2" :style="{background:saveDone?'rgba(40,199,111,0.08)':'rgba(255,255,255,0.03)'}">
              <feather-icon :icon="saveDone?'CheckCircleIcon':'CircleIcon'" :svgClasses="saveDone?'text-success':'text-grey'" size="16" class="flex-shrink-0" />
              <span class="font-semibold text-sm flex-1">Save Configuration</span>
              <span class="text-xs font-medium" :class="saveDone?'text-success':'text-grey'">{{ [sw1Completion.saved,sw2Completion.saved].filter(Boolean).length }}/2</span>
            </div>
            <div class="px-3 py-2">
              <div v-for="swKey in ['sw1','sw2']" :key="'s-'+swKey" class="mb-2">
                <span class="inline-block text-xs font-semibold px-2 py-px rounded mb-1" style="background:rgba(255,255,255,0.07);letter-spacing:.05em">{{ swKey.toUpperCase() }}</span>
                <div class="space-y-1 ml-1">
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:getState(swKey).endDone?'#28C76F':'transparent',border:'2px solid '+(getState(swKey).endDone?'#28C76F':'#6b7280')}"></div>
                    <code class="text-base" :class="getState(swKey).endDone?'text-success':''">end</code>
                  </div>
                  <div class="flex items-center gap-2">
                    <div class="flex-shrink-0 rounded-full" :style="{width:'8px',height:'8px',background:getCompletion(swKey).saved?'#28C76F':'transparent',border:'2px solid '+(getCompletion(swKey).saved?'#28C76F':'#6b7280')}"></div>
                    <code class="text-base" :class="getCompletion(swKey).saved?'text-success':''">copy running-config startup-config</code>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </vx-card>
      </div>

      <!-- Right: Terminals -->
      <div class="vx-col lg:w-8/12 md:w-7/12 sm:w-5/5">
        <div style="height: 35rem">
          <vue-command v-show="sel==='sw1'" key="sw1" id="sw1_terminal" :commands="sw1Commands" :prompt="sw1Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="SW1" />
          <vue-command v-show="sel==='sw2'" key="sw2" id="sw2_terminal" :commands="sw2Commands" :prompt="sw2Prompt" :show-intro="true" intro="Cisco IOS Software, Version 15.2(4)M1 — Type 'help' for available commands." style="background-color:#111111;border:1px solid #181d2a;border-radius:0.5rem;height:100%" title="SW2" />
        </div>

        <!-- Topology -->
        <div class="topology-card">
          <img :src="topologyImage" alt="Network topology" class="topology-img" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueCommand, { createStdout, createStderr } from 'vue-command';
import 'vue-command/dist/vue-command.css';

const HELP =
  'Commands:<br>' +
  '&nbsp;interface range e0/0 - 1<br>' +
  '&nbsp;channel-group 44 mode active<br>' +
  '&nbsp;no shutdown | no shut<br>' +
  '&nbsp;interface Port-channel 44<br>' +
  '&nbsp;switchport trunk encapsulation dot1q<br>' +
  '&nbsp;switchport mode trunk<br>' +
  '&nbsp;end | exit<br>' +
  '&nbsp;show vlan<br>' +
  '&nbsp;configure terminal | conf t<br>' +
  '&nbsp;switchport trunk native vlan 746<br>' +
  '&nbsp;copy running-config startup-config<br>';

const SHOW_VLAN =
  'VLAN&nbsp;Name&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Status&nbsp;&nbsp;&nbsp;Ports<br>' +
  '---- &nbsp;-------------------- &nbsp;--------- &nbsp;-------------------<br>' +
  '1&nbsp;&nbsp;&nbsp;&nbsp;default&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;active<br>' +
  '746&nbsp;&nbsp;MONITORING&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;active&nbsp;&nbsp;&nbsp;Et0/0, Et0/1<br>';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      topologyImage: 'https://ip-learn.b-cdn.net/simulations/ccna-topologies/LACP_Configuration_Sim.png',
      sel: 'sw1',
      totalScore: 0,

      task123Items: [
        { key: 'rangeConfigured', cmd: 'interface range e0/0 - 1' },
        { key: 'channelGroup',    cmd: 'channel-group 44 mode active' },
        { key: 'noShut',          cmd: 'no shutdown' },
        { key: 'portChannel',     cmd: 'interface Port-channel 44' },
        { key: 'encapsulation',   cmd: 'switchport trunk encapsulation dot1q' },
        { key: 'trunkMode',       cmd: 'switchport mode trunk' },
      ],
      task4Items: [
        { key: 'endForShow',   cmd: 'end' },
        { key: 'showVlan',     cmd: 'show vlan' },
        { key: 'confTerminal', cmd: 'configure terminal' },
        { key: 'portChannel2', cmd: 'interface Port-channel 44' },
        { key: 'nativeVlan',   cmd: 'switchport trunk native vlan 746' },
      ],

      sw1: { mode: 'exec', currentInterface: null, endDone: false },
      sw2: { mode: 'exec', currentInterface: null, endDone: false },

      sw1Completion: {
        rangeConfigured: false, channelGroup: false, noShut: false,
        portChannel: false, encapsulation: false, trunkMode: false,
        endForShow: false, showVlan: false, confTerminal: false,
        portChannel2: false, nativeVlan: false, saved: false,
      },
      sw2Completion: {
        rangeConfigured: false, channelGroup: false, noShut: false,
        portChannel: false, encapsulation: false, trunkMode: false,
        endForShow: false, showVlan: false, confTerminal: false,
        portChannel2: false, nativeVlan: false, saved: false,
      },

      sw1Commands: {
        help:            () => createStdout(HELP),
        enable:          () => createStdout(''),
        configure:       (x) => this.iosConfigure('sw1', x),
        conf:            (x) => this.iosConfigure('sw1', x),
        exit:            () => this.iosExit('sw1'),
        end:             () => this.iosEnd('sw1'),
        interface:       (x) => this.iosInterface('sw1', x),
        int:             (x) => this.iosInterface('sw1', x),
        'channel-group': (x) => this.iosChannelGroup('sw1', x),
        no:              (x) => this.iosNo('sw1', x),
        switchport:      (x) => this.iosSwitchport('sw1', x),
        show:            (x) => this.iosShow('sw1', x),
        copy:            (x) => this.iosCopy('sw1', x),
      },
      sw2Commands: {
        help:            () => createStdout(HELP),
        enable:          () => createStdout(''),
        configure:       (x) => this.iosConfigure('sw2', x),
        conf:            (x) => this.iosConfigure('sw2', x),
        exit:            () => this.iosExit('sw2'),
        end:             () => this.iosEnd('sw2'),
        interface:       (x) => this.iosInterface('sw2', x),
        int:             (x) => this.iosInterface('sw2', x),
        'channel-group': (x) => this.iosChannelGroup('sw2', x),
        no:              (x) => this.iosNo('sw2', x),
        switchport:      (x) => this.iosSwitchport('sw2', x),
        show:            (x) => this.iosShow('sw2', x),
        copy:            (x) => this.iosCopy('sw2', x),
      },
    };
  },

  computed: {
    sw1Prompt() {
      const m = this.sw1.mode;
      if (m === 'config') return 'SW1(config)#';
      if (m === 'config-if') return 'SW1(config-if)#';
      return 'SW1#';
    },
    sw2Prompt() {
      const m = this.sw2.mode;
      if (m === 'config') return 'SW2(config)#';
      if (m === 'config-if') return 'SW2(config-if)#';
      return 'SW2#';
    },
    task123Progress() {
      const keys = ['rangeConfigured','channelGroup','noShut','portChannel','encapsulation','trunkMode'];
      return keys.filter(k => this.sw1Completion[k]).length + keys.filter(k => this.sw2Completion[k]).length;
    },
    task123Done() {
      const keys = ['rangeConfigured','channelGroup','noShut','portChannel','encapsulation','trunkMode'];
      return keys.every(k => this.sw1Completion[k] && this.sw2Completion[k]);
    },
    task4Progress() {
      const keys = ['endForShow','showVlan','confTerminal','portChannel2','nativeVlan'];
      return keys.filter(k => this.sw1Completion[k]).length + keys.filter(k => this.sw2Completion[k]).length;
    },
    task4Done() {
      const keys = ['endForShow','showVlan','confTerminal','portChannel2','nativeVlan'];
      return keys.every(k => this.sw1Completion[k] && this.sw2Completion[k]);
    },
    saveDone() { return this.sw1Completion.saved && this.sw2Completion.saved; },
  },

  mounted() {
    this.dataLocal.options.showMarkButton = false;
    this.$emit('simulation_update_options', this.dataLocal);
  },

  methods: {
    getState(swKey) { return this[swKey]; },
    getCompletion(swKey) { return this[swKey + 'Completion']; },

    // Green guidance message rendered inside the terminal
    guide(msg) {
      return `<span style="color:#28C76F;display:block;margin-top:6px;padding:4px 8px;border-left:2px solid #28C76F;font-size:0.85em;line-height:1.5">${msg}</span>`;
    },

    modeErr(state, needed) {
      if (state.mode === needed) return null;
      if (needed === 'config') {
        if (state.mode === 'exec') return createStderr('% Must be in configuration mode — type "configure terminal" first');
        if (state.mode === 'config-if') return createStderr('% Must be in configuration mode — type "exit" first');
      }
      if (needed === 'exec') return createStderr('% Must be in privileged EXEC mode — type "end" or "exit" first');
      if (needed === 'config-if') return createStderr('% Must be in interface config mode — enter an interface first');
      return createStderr('% Invalid input detected');
    },

    iosConfigure(swKey, x) {
      const state = this[swKey]; const c = this[swKey + 'Completion'];
      const me = this.modeErr(state, 'exec'); if (me) return me;
      if (x._[1] === 'terminal' || x._[1] === 't') {
        state.mode = 'config';
        if (c.showVlan && !c.confTerminal) {
          c.confTerminal = true; this.updateScore();
          return createStdout(
            'Enter configuration commands, one per line.  End with CNTL/Z.' +
            this.guide('Back in config mode. You confirmed VLAN 746 is MONITORING — now set it as the native VLAN on the trunk so untagged frames are classified as monitoring traffic. → Next: interface Port-channel 44'),
          );
        }
        return createStdout('Enter configuration commands, one per line.  End with CNTL/Z.');
      }
      return createStderr('% Invalid input detected');
    },

    iosExit(swKey) {
      const state = this[swKey]; const c = this[swKey + 'Completion'];
      if (state.mode === 'config-if') {
        state.mode = 'config';
      } else if (state.mode === 'config') {
        state.mode = 'exec';
        state.endDone = true;
        if (c.trunkMode && !c.endForShow) {
          c.endForShow = true; this.updateScore();
          return createStdout(this.guide('Back in privileged EXEC mode. Before setting the native VLAN, verify which VLAN is MONITORING using show vlan. → Next: show vlan'));
        }
      }
      return createStdout('');
    },

    iosEnd(swKey) {
      const state = this[swKey]; const c = this[swKey + 'Completion'];
      const wasConfig = state.mode !== 'exec';
      state.mode = 'exec';
      if (wasConfig) state.endDone = true;
      if (c.trunkMode && !c.endForShow) {
        c.endForShow = true; this.updateScore();
        return createStdout(this.guide('Back in privileged EXEC mode. Before setting the native VLAN, verify which VLAN is MONITORING using show vlan. → Next: show vlan'));
      }
      return createStdout('');
    },

    iosInterface(swKey, x) {
      const state = this[swKey]; const c = this[swKey + 'Completion'];
      // Allow from config OR config-if (IOS lets you switch interfaces without exiting)
      if (state.mode !== 'config' && state.mode !== 'config-if') {
        return this.modeErr(state, 'config');
      }
      const sub = (x._[1] || '').toLowerCase();

      if (sub === 'range') {
        state.mode = 'config-if'; state.currentInterface = 'range';
        if (!c.rangeConfigured) { c.rangeConfigured = true; this.updateScore(); }
        return createStdout(this.guide('Selected physical interfaces E0/0 and E0/1 in range mode — both links between this switch and its peer. They will be bundled together into a single logical EtherChannel. → Next: channel-group 44 mode active'));
      }

      if (sub === 'port-channel') {
        state.mode = 'config-if'; state.currentInterface = 'po44';
        if (!c.portChannel) {
          c.portChannel = true; this.updateScore();
          return createStdout(this.guide('Entered Port-channel 44 — the logical interface that aggregates E0/0 and E0/1 into one bundle. All VLAN and trunking config goes here, not on the physical interfaces. → Next: switchport trunk encapsulation dot1q'));
        }
        if (c.confTerminal && !c.portChannel2) {
          c.portChannel2 = true; this.updateScore();
          return createStdout(this.guide('Back in Port-channel 44. Ready to assign the native VLAN. → Next: switchport trunk native vlan 746'));
        }
        return createStdout('');
      }

      // generic interface
      const iface = (x._[1] || '').toLowerCase().replace(/^(ethernet|e|fastethernet|fa|f|gigabitethernet|gi)/, 'e');
      state.mode = 'config-if'; state.currentInterface = iface;
      return createStdout('');
    },

    iosChannelGroup(swKey, x) {
      const state = this[swKey]; const c = this[swKey + 'Completion'];
      const me = this.modeErr(state, 'config-if'); if (me) return me;
      if (state.currentInterface !== 'range') {
        return createStderr('% channel-group must be configured on a physical interface range — use "interface range e0/0 - 1" first');
      }
      if (x._[2] === 'mode' && x._[3] === 'active' && !c.channelGroup) {
        c.channelGroup = true; this.updateScore();
        return createStdout(this.guide('Bound both interfaces to Port-channel 44 using LACP active mode. Active mode means this switch actively negotiates the bundle with the peer — both switches must have LACP configured. → Next: no shutdown'));
      }
      return createStdout('');
    },

    iosNo(swKey, x) {
      const state = this[swKey]; const c = this[swKey + 'Completion'];
      if (x._[1] === 'shutdown' || x._[1] === 'shut') {
        const me = this.modeErr(state, 'config-if'); if (me) return me;
        if (!c.noShut) { c.noShut = true; this.updateScore(); }
        return createStdout(
          '%LINK-5-CHANGED: Interface Ethernet0/0, changed state to up<br>' +
          '%LINK-5-CHANGED: Interface Ethernet0/1, changed state to up' +
          this.guide('Physical links E0/0 and E0/1 are now active. The EtherChannel bundle can form with the peer switch. → Next: interface Port-channel 44 to configure trunk settings on the logical interface'),
        );
      }
      return createStderr('% Invalid input detected');
    },

    iosSwitchport(swKey, x) {
      const state = this[swKey]; const c = this[swKey + 'Completion'];
      const me = this.modeErr(state, 'config-if'); if (me) return me;
      if (state.currentInterface !== 'po44') {
        return createStderr('% switchport trunk commands must be applied on Port-channel 44 — type "interface Port-channel 44" first');
      }

      if (x._[1] === 'trunk' && x._[2] === 'encapsulation' && x._[3] === 'dot1q') {
        if (!c.encapsulation) { c.encapsulation = true; this.updateScore(); }
        return createStdout(this.guide('Set 802.1Q encapsulation — the IEEE standard protocol for tagging VLAN traffic. Each Ethernet frame crossing this trunk gets a 4-byte VLAN tag inserted, identifying which VLAN it belongs to. Required before trunk mode can be set. → Next: switchport mode trunk'));
      }

      if (x._[1] === 'mode' && x._[2] === 'trunk') {
        if (!c.trunkMode) { c.trunkMode = true; this.updateScore(); }
        return createStdout(this.guide('Port-channel 44 is now a trunk link. All VLANs can traverse this EtherChannel between the two switches, with 802.1Q tags identifying each VLAN\'s traffic. ' + (this.task123Done ? '→ Both switches configured. Now move to Task 4: set the native VLAN.' : '→ Repeat all of Tasks 1-3 on the other switch before proceeding to Task 4.')));
      }

      if (x._[1] === 'trunk' && x._[2] === 'native' && x._[3] === 'vlan') {
        if (parseInt(x._[4]) === 746 && !c.nativeVlan) {
          c.nativeVlan = true; this.updateScore();
          return createStdout(this.guide('VLAN 746 (MONITORING) is now the native VLAN on this trunk. Untagged frames arriving on this trunk will be treated as MONITORING traffic — useful for management tools that send untagged packets. ' + (this.task4Done ? '→ Both switches configured. Save both configs!' : '→ Repeat on the other switch, then save both configs.')));
        }
        return createStdout('');
      }
      return createStderr('% Invalid input detected');
    },

    iosShow(swKey, x) {
      const state = this[swKey]; const c = this[swKey + 'Completion'];
      if (x._[1] === 'vlan') {
        const me = this.modeErr(state, 'exec'); if (me) return me;
        if (!c.showVlan) { c.showVlan = true; this.updateScore(); }
        return createStdout(
          SHOW_VLAN +
          this.guide('Confirmed: VLAN 746 is named MONITORING. The native VLAN carries untagged traffic on a trunk — any untagged frames will be assigned to this VLAN. Setting 746 as native aligns untagged management traffic with the MONITORING VLAN. → Next: configure terminal → interface Port-channel 44 → switchport trunk native vlan 746'),
        );
      }
      return createStderr('% Invalid input detected');
    },

    iosCopy(swKey, x) {
      const state = this[swKey]; const c = this[swKey + 'Completion'];
      const me = this.modeErr(state, 'exec'); if (me) return me;
      if (x._[1] === 'running-config' && x._[2] === 'startup-config') {
        if (!c.saved) { c.saved = true; this.updateScore(); }
        return createStdout(
          'Building configuration...<br>[OK]' +
          this.guide('Configuration saved to NVRAM. This switch retains all settings across reboots.' + (this.saveDone ? ' ✓ Both switches saved — simulation complete!' : ' → Save the other switch too.')),
        );
      }
      return createStderr('% Invalid input detected');
    },

    updateScore() {
      let score = 0;
      [this.sw1Completion, this.sw2Completion].forEach(c => {
        Object.values(c).forEach(v => { if (v) score++; });
      });
      this.totalScore = score;
      this.$emit('simulation_update_score', score);
      if (score >= 24) setTimeout(() => this.$emit('simulation_full_correct', score), 500);
    },
  },

  components: { VueCommand },
  props: { data: { type: Object, required: true } },
};
</script>

<style>
#sw1_terminal, #sw2_terminal { overflow: hidden !important; }

.topology-card {
  margin-top: 1.5rem;
  background-color: #111111;
  border: 1px solid #181d2a;
  border-radius: 0.5rem;
  overflow: hidden;
  line-height: 0;
}
.topology-img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
}
</style>

